<template>
  <div>
    <!-- begin #page-container -->
    <div id="page-container" class="page-container fade page-sidebar-fixed page-header-fixed">
      <!-- begin #header -->
      <div id="header" class="header navbar-default">
        <!-- begin navbar-header -->
        <div class="navbar-header" >
          <a class="navbar-brand">
            <img src="@/assets/logo.png" style="margin-right:30px;">
            <b>中创</b> 分销
          </a>
          <button type="button" class="navbar-toggle" data-click="sidebar-toggled">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <!-- end navbar-header -->

        <!-- begin header-nav -->
        <ul class="navbar-nav navbar-right">
          <li class="dropdown navbar-user">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <img src="../../static/img/user/user-13.jpg" alt>
              <span class="d-none d-md-inline">{{userName}}</span>
              <b class="caret"></b>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <router-link to="/changepassword" style="color:#212529;text-decoration:none">
                <a class="dropdown-item">修改密码</a>
              </router-link>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="LoginOut">退出</a>
            </div>
          </li>
        </ul>
        <!-- end header navigation right -->
      </div>
      <!-- end #header -->

      <!-- begin #sidebar -->
      <div id="sidebar" class="sidebar" :class="{'sideWidth':SideSelected}">
        <!-- begin sidebar scrollbar -->
        <div data-scrollbar="true" data-height="100%"  >
          <!-- begin sidebar user -->
          <ul class="nav"  v-if="!SideSelected">
            <li class="nav-profile">
              <a href="javascript:;" data-toggle="nav-profile">
                <div class="cover with-shadow"></div>

                <div class="info" @click="IndexClick">
                  <router-link
                    :to="srcrouter"
                    style="color:white;font-size:18px;text-decoration:none;"
                  >{{Title}}</router-link>
                </div>
              </a>
            </li>
          </ul>
          <!-- end sidebar user -->
          <!-- begin sidebar nav -->
          <ul class="nav">
            <li v-for="(item,index) in MenuList" :key="index" >
              <a href="javascript:;" @click="MenuClick(index,item)">
                <b class="caret" :class="{'menucaret':!item.checked}"  v-if="!SideSelected"></b>
                <i class="fa" :class="item.urlIcon"></i>
                <span class="hasTitle" v-if="!SideSelected">{{item.menuName}}</span>
              </a>
              <div v-if="!item.checked&&item.childMenus.length!== 0 && !SideSelected">
              <ul class="MenuUl">
                <li class="hasTitles" v-for="(val,index2) in item.childMenus" :key="index2"  @click="MenuClicks(index2,val,item,index)">
                  <router-link :to="val.url" class= "menuchildren" :class="{'menuchecked':!item.checked&&!val.menuchecked}">{{val.menuName}}</router-link>
                </li>
              </ul>
              </div>
            </li>
            <li>
              <a class="sidebar-minify-btn" @click="SideClick">
                <i class="fa fa-angle-double-left"></i>
              </a>
            </li>
          </ul>
          <!-- end sidebar nav -->
        </div>
        <!-- end sidebar scrollbar -->
      </div>
      <!-- end #sidebar -->
      <div class="RightContent" :class="{'RightContentWidth':SideSelected}">
        <router-view></router-view>
      </div>
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" >
      <div  class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将退出系统!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure">确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- end page container -->
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";
export default {
  name: "Home",
  data() {
    return {
      MenuList:[],
      Title:'',
      outerVisible:false,
      userName:'',
      srcrouter:'',
      SideSelected: false
    };
  },
  mounted: function() {
    App.init();
    this.initdata();
    if(localStorage.getItem('userName')){
      this.userName = JSON.parse(localStorage.getItem('userName')).userName;
    }
    eventBus.$on("SeriesBackEmit", () => {
     this.MenuList.forEach((val,index)=>{
       val.childMenus.forEach(element=>{
         element.menuchecked = true;
         if(element.url === "/brandmanagement"){
           element.menuchecked = false;
         }
       })
         this.$set(this.MenuList,index,val)
     })

    });
    eventBus.$on("SeriesEmit", () => {
      this.MenuList.forEach((val,index)=>{
        val.childMenus.forEach(element=>{
          element.menuchecked = true;
          if(element.url === "/seriesmanagement"){
            element.menuchecked = false;
          }
        })
        this.$set(this.MenuList,index,val)
      })
    });
  },
  beforeDestroy () {
    eventBus.$off("SeriesEmit");
    eventBus.$off("SeriesBackEmit");
  },
  watch: {
    $route(to,from){
      this.MenuList.forEach(element=>{
        element.checked = true;
        element.childMenus.forEach(val=>{
          val.menuchecked = true;
          if(val.url === to.path){
            val.menuchecked = false;
            element.checked = false;
          }else if(val.url === '/index'){
            element.checked = true;
            val.menuchecked = true;
          }
        })
      })
    }
  },
  methods: {
    SideClick(){
      this.SideSelected = !this.SideSelected;
    },
    IndexClick(){
      this.MenuList.forEach(element=>{
        element.checked = true;
        element.childMenus.forEach(val=>{
          val.menuchecked = true;
        })
      })
    },
    initdata(){
      let that = this;
      const options = {
        url: "/user/UserController/getLoginMenus",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          systemId:3
        }
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.Title = response.data.data[0].menuName;
            that.srcrouter = response.data.data[0].url;
            response.data.data = response.data.data.slice(1,response.data.data.length)
            that.MenuList = response.data.data;
            that.MenuList.forEach(element=>{
              element.checked = true;
              element.childMenus.forEach(val=>{
                val.menuchecked = true;
                if(val.url === that.$route.path){
                  val.menuchecked = false;
                  element.checked = false;
                }else if(val.url === '/index'){
                  element.checked = true;
                  val.menuchecked = true;
                }
              })

            })

          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    MenuClick(index,item){

      item.checked = !item.checked;
      this.$set(this.MenuList,index,item)
    },
    MenuClicks(index,val,item,index2){

         this.MenuList.forEach(element=>{
           element.checked = true;
              element.childMenus.forEach(val2=>{
                val2.menuchecked = true;
              })

            })
      item.checked = false;
      val.menuchecked = false;
      this.$set(this.MenuList,index2,item)
    },
    MakeSure(){
       let that = this;
      const options = {
        url: "/user/UserController/logout",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {

            that.$router.push({ path: "/login" });
            localStorage.removeItem("Authorization");
            localStorage.removeItem('userName');
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    LoginOut() {
      this.outerVisible = true;

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.RightContentWidth{
  width: calc(100% - 60px) !important;
}
.RightContent {
  width: calc(100% - 220px);
  float: right;
}
.hasTitle {
  float: left;
  font-size: 12px;
  padding-left: 16px;
}
.hasTitles {
  text-align: left;
  padding-left: 16px;
}
.MenuUl{
  padding: 3px 20px 3px 43px;
  display: block;
  color: #889097;
  text-decoration: none;
  position: relative;
}
.menucaret{
  transform: rotate(90deg);
}
.menuchecked{
  color:#fff !important;
}
.menuchildren{
  color: #889097;text-decoration:none;height:28px;display:block;line-height:28px;font-size:12px;
}
.sideWidth{
  width:60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue